/**
 * Meta blocked mindtale.ro ("Some website data blocked", Events Manager,
 * Oct 2026) because the URLs and titles the pixel sends look like medical
 * conditions: /depresie, /anxietate, /teste/..., the Zenyra chat. Meta files
 * the whole domain as health, which empties the website audiences and starves
 * ad optimisation.
 *
 * So Meta only ever hears about pages on this allowlist, the neutral booking
 * and brand pages. Everything else (condition and therapy pages, Sanity topic
 * pages, /teste, /zenyra, /gaseste-terapeut, the blog) sends nothing from the
 * browser. Their conversions still reach Meta through the server copies,
 * with the URL reduced by `metaSafeUrl`.
 *
 * An allowlist, not a denylist: new condition pages land at /<slug> from
 * Sanity all the time and must stay out without anyone remembering to add them.
 */
const META_TRACKABLE: RegExp[] = [
  /^\/$/,
  /^\/sesiune-cunoastere\/?$/,
  /^\/terapeuti(\/[^/]+)?\/?$/,
  /^\/cat-costa\/?$/,
  /^\/despre-noi\/?$/,
  /^\/contact\/?$/,
  /^\/colaborare(\/[^/]+)?\/?$/,
  /^\/prima-sedinta\/?$/,
  /^\/ce-este-psihoterapia\/?$/,
  /^\/diaspora\/?$/,
  /^\/fondul-social\/?$/,
  /^\/webinar-limite\/?$/,
];

export function isMetaTrackablePath(pathname: string): boolean {
  return META_TRACKABLE.some((re) => re.test(pathname));
}

/**
 * The URL to report to Meta as `event_source_url`: origin plus path, never the
 * query string, and the bare origin for any page off the allowlist.
 */
export function metaSafeUrl(url: string | null | undefined): string {
  const fallback = process.env.NEXT_PUBLIC_SITE_URL || "https://mindtale.ro";
  if (!url) return `${fallback}/`;
  try {
    const u = new URL(url, fallback);
    return isMetaTrackablePath(u.pathname) ? `${u.origin}${u.pathname}` : `${u.origin}/`;
  } catch {
    return `${fallback}/`;
  }
}
